import { FieldTypes } from 'mmv/inquiry/fields';

//TODO add purpose description of this definition
export const mmvSteps: Record<keyof FieldTypes, string> = {
  contractDetails: 'contractDetails',
  customerDataPage: 'customerDataPage',
} as const;
